/* unplugin-vue-components disabled */import { render } from "./table-head.vue?vue&type=template&id=85cb807a&scoped=true"
import script from "./table-head.vue?vue&type=script&lang=js"
export * from "./table-head.vue?vue&type=script&lang=js"

import "./table-head.vue?vue&type=style&index=0&id=85cb807a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85cb807a"],['__file',"src/components/data-table/table-head.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85cb807a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85cb807a', __exports__)) {
    api.reload('85cb807a', __exports__)
  }
  
  module.hot.accept("./table-head.vue?vue&type=template&id=85cb807a&scoped=true", () => {
    api.rerender('85cb807a', render)
  })

}


export default __exports__